import tw, { styled } from 'twin.macro';
import Link from '@/components/Link/Link';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledEyebrow = styled.span`
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`text-tag-m text-primary-p1`}
  ${tw`mb-2`}
`;

export const StyledHeadline = styled.h2`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-display-xl text-secondary-s1 lg:text-display-xl`}
`;

export const StyledBody = styled.div`
  ${tw`font-inter`}
  ${tw`text-body-l text-primary-p1`}
  ${tw`mt-5 lg:mt-3`}

  a {
    ${tw`text-secondary-s1`}
    ${tw`hover:underline no-underline`}
  }
`;

export const StyledButton = styled(Link)`
  ${tw`mt-5`}
`;

export const StyledHeaderContent = styled.div`
  ${tw`col-span-4 lg:col-span-6`}
  ${tw`flex flex-col items-center`}
`;

export const StyledHeaderImage = styled.div`
  ${tw`col-span-4 lg:col-span-6`}
`;

export const StyledImage = styled(ImageElement)`
  ${tw`rounded-md`}
`;

export const StyledHeader = styled.div<{
  imageDirection?: Queries.kontent_item_column_block_elements_image_direction_enum | null;
  hasNoBody?: boolean;
}>`
  ${tw`col-span-4`}
  ${tw`grid grid-cols-4 gap-x-2 gap-y-8 md:grid-cols-8 md:gap-3 lg:grid-cols-12 lg:gap-4`}
  ${tw`auto-rows-min`}

  ${StyledHeaderImage} {
    ${({ imageDirection }) => {
      switch (imageDirection) {
        case 'left':
          return tw`col-start-1`;
        case 'right':
          return tw`md:col-start-5 lg:col-start-7`;
        default:
          return tw`md:hidden`;
      }
    }}
  }

  ${StyledHeaderContent} {
    ${tw`text-center`}
    ${({ imageDirection }) => {
      switch (imageDirection) {
        case 'left':
        case 'right':
          return [tw`md:items-start`, tw`md:text-left`];
        default:
          return [
            tw`md:col-span-8 lg:col-span-8 lg:col-start-3`,
            tw`md:items-center md:text-center`,
          ];
      }
    }}
  }

  ${({ hasNoBody }) => hasNoBody && tw`mb-4`}
`;
